export const url = process.env.REACT_APP_API_URL || (typeof window !== "undefined" && window.REACT_APP_API_URL) || "https://localhost:7215";
